import React from 'react';
import MultiImageSection from './MultiImageSection';
import * as FiIcons from 'react-icons/fi';

const { FiXCircle } = FiIcons;

function NewAvoidanceSection({ 
  images, 
  onAddImage, 
  onDeleteImage 
}) {
  return (
    <MultiImageSection
      title="Chi non voglio essere"
      description="Carica fino a 5 immagini per ricordarti i comportamenti o gli stili di vita che vuoi evitare."
      icon={FiXCircle}
      colorClass="red"
      images={images}
      onAddImage={onAddImage}
      onDeleteImage={onDeleteImage}
      maxImages={5}
    />
  );
}

export default NewAvoidanceSection;